// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3sJ3W","select":"Header_select__1Hito","clinic":"Header_clinic__3uBkP"};